import angular from "angular";

angular
    .module('app')
    .config(['ChartJsProvider', function (ChartJsProvider) {
        ChartJsProvider.setOptions({
            chartColors: ['#62fc03', '#03bafc'],
            responsive: false
        });
        ChartJsProvider.setOptions('line', {
            showLines: true
        });
    }])
    .component('mainChart', {
        template: require('./main-chart.html'),
        controller: ['$http', 'moment', controller],
        bindings: {}
    });

function controller ($http, moment) {

    let $ctrl = this;

    $ctrl.labels = [];
    $ctrl.data = [];

    $ctrl.$onInit = function () {
        $ctrl.today = moment();
        $ctrl.getData(-20, 0);
    };

    $ctrl.getData = function (start, end) {

        $ctrl.loading = true;

        let startDate = $ctrl.today.clone().add(start, 'days').format('YYYY-MM-DD');
        let endDate = $ctrl.today.clone().add(end, 'days').format('YYYY-MM-DD');

        for (let i = end; i >= start; i--) {
            $ctrl.data.unshift(0);
            $ctrl.labels.unshift($ctrl.today.clone().add(i, 'days').format('D MMM'));
        }

        $http
            .get('/admin/get-users-chart-data', {
                params: {
                    start_date: startDate,
                    end_date: endDate
                }
            })
            .then(
                function (response) {

                    $ctrl.loading = false;

                    let totals = response.data;

                    totals.forEach(function (item) {
                        let diff = $ctrl.today.diff(item.create_date, 'days');
                        let ind = $ctrl.data.length - 1 - diff;
                        $ctrl.data[ind] = item.count;
                    });

                    $ctrl.prev = start;
                },
            );
    };

    $ctrl.showMorePrevious = function () {
        $ctrl.getData($ctrl.prev - 7, $ctrl.prev - 1);
    };

}
